import { CreateShopProductDto, ShopProductDto, PatchShopProductDto } from '@careapp-group/ng-sdk';
import { CaEntityActionsFactory } from '../../../store/entity-state/entity-actions-factory';
import { MarketProductFilterType } from './market-management-products.reducer';
import { createAction, props } from '@ngrx/store';

class MarketManagementProductsActions extends CaEntityActionsFactory<
  ShopProductDto,
  CreateShopProductDto,
  PatchShopProductDto,
  MarketProductFilterType
> {
  constructor() {
    super('MarketManagementProducts');
  }

  get UPDATE_SEGMENT_PAGE_COUNT() {
    return `[${this.type}][Update] segment page count`;
  }

  UpdateSegmentPageCountAction = createAction(
    this.UPDATE_SEGMENT_PAGE_COUNT,
    props<{ segment: string; count: number }>(),
  );
}

export const MarketManagementProductActions = new MarketManagementProductsActions();
